import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer/footer.component';
import { NavbarComponent } from './navbar/navbar.component';
import { MatDialogModule } from '@angular/material/dialog';
import { CustomDatePipe } from '../pipe/date.pipes';
import { NullToDashPipe } from '../pipe/string.pipes';
import { FormatNumberPipe } from '../pipe/monto.pipe';
import { DateMonthPickerComponent } from './date-month-picker/date-month-picker.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { TablerIconsModule } from 'angular-tabler-icons';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [
    CustomDatePipe,
    FooterComponent,
    NavbarComponent,
    NullToDashPipe,
    DateMonthPickerComponent,
  ],
  imports: [
    CommonModule,
    FormatNumberPipe,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    TablerIconsModule,
    FormsModule,
    MatIconModule,
    MatButtonModule,
  ],
  exports: [
    CustomDatePipe,
    NullToDashPipe,
    FormatNumberPipe,
    DateMonthPickerComponent,
  ],
})
export class SharedModule {}
